import { BsBriefcase } from "react-icons/bs";
import { SlGraduation } from "react-icons/sl";

import { SectionTitle } from "../../components/SectionTitle/SectionTitle";
import { PanelItem } from "../../components/PanelItem/PanelItem";
import { TabPanels } from "../../components/Tabs/TabPanels/TabPanels";
import { Container } from "../../layout/Container/Container";
import { Section } from "../../layout/Section/Section";
import { TabList } from "../../components/Tabs/TabList/TabList";
import { Panel } from "../../components/Tabs/Panel/Panel";
import { Tabs } from "../../components/Tabs/Tabs";
import { Tab } from "../../components/Tabs/Tab/Tab";
import { EDUCATION_DATA, WORk_DATA } from "../../utils/app-content";
import styles from "./Qualification.module.css";

export const Qualification = () => {
  return (
    <Section id="experience">
      <SectionTitle
        title="Work Experience & Education"
        subtitle="My Career & Educational Journey"
      />

      <Container centerContent={true}>
        <Tabs>
          <TabList>
            <Tab id={0}>
              <BsBriefcase /> <span>Work Experiences</span>
            </Tab>
            <Tab id={1}>
              <SlGraduation />
              <span>Education & Training</span>
            </Tab>
          </TabList>

          <TabPanels>
            <Panel id={0}>
              {WORk_DATA.map((item, index) => (
                <PanelItem
                  key={index}
                  title={item.title}
                  subtitle={item.subtitle}
                  date={item.date}
                  trackOnLeft={index % 2 !== 0}
                />
              ))}
            </Panel>
            <Panel id={1}>
              {EDUCATION_DATA.map((item, index) => (
                <PanelItem
                  key={index}
                  title={item.title}
                  subtitle={item.subtitle}
                  date={item.date}
                  trackOnLeft={index % 2 === 0}
                />
              ))}
            </Panel>
          </TabPanels>
        </Tabs>
      </Container>
    </Section>
  );
};
